export default {
	content_plural: 'Conteúdos',
	content: 'Conteúdo | Conteúdos',
	finished: 'Finalizada',
	how_do_you_rate_this_trail: 'Como você avalia esta trilha?',
	loading_trails: 'Carregando trilhas',
	no_trails_are_available_at_the_moment: 'Não há trilhas disponíveis no momento',
	no_trails_are_available_with_the_selected_filter:
		'Não há trilhas disponíveis para o filtro selecionado',
	only_available_when_finished_trail: 'Disponível somente após a conclusão da trilha',
}
